module.exports = __webpack_public_path__ + "img/tuscaloosa-city-logo.cd119373.jpg";